export const EnumPageMeta: IEnumPageMeta = {
  /** 页面名称 */
  title: '云学堂鉴权',
  layout: null,
  login: true,
};
/**
 * 字段描述 枚举
 */
export enum EnumLocaleLabel {}

export default {
  en: {},
  zh: {},
};
